import { render, staticRenderFns } from "./Paginator.vue?vue&type=template&id=4b8a8fda&scoped=true&"
import script from "./Paginator.vue?vue&type=script&lang=js&"
export * from "./Paginator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8a8fda",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/user/projects/zp-front-up/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b8a8fda')) {
      api.createRecord('4b8a8fda', component.options)
    } else {
      api.reload('4b8a8fda', component.options)
    }
    module.hot.accept("./Paginator.vue?vue&type=template&id=4b8a8fda&scoped=true&", function () {
      api.rerender('4b8a8fda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/paginator/Paginator.vue"
export default component.exports